<template>
    <span class="ds-ex-avatar" :class="[`is-${tone}`, `is-${size}`, { 'is-ring': ring }]" :title="title || undefined">
        <img v-if="person?.avatar" :src="person.avatar" alt="" loading="lazy">
        <template v-else>{{ initials(person) }}</template>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { avatarTone, initials } from './exchangeFormat'

const props = withDefaults(defineProps<{
    person: { id: string, first_name: string, last_name: string, avatar?: string | null } | null
    size?: 'sm' | 'md'
    ring?: boolean
    title?: string
}>(), { size: 'md', ring: false, title: '' })

const tone = computed(() => avatarTone(props.person?.id))
</script>
